// @ts-nocheck

import * as Yup from 'yup';

export const SCHEMA = Yup.object().shape({
  name: Yup.string().when(['$inputs', '$showPassword'], (inputs, showPassword, schema) =>
    inputs?.name && !showPassword ? schema.required('Required field').max(50) : undefined
  ),

  password: Yup.string().when(['$inputs', '$showPassword'], (inputs, showPassword, schema) =>
    inputs?.password && !showPassword ? schema.required('Required field').max(50) : undefined
  ),

  email: Yup.string().when(['$inputs', '$showPassword'], (inputs, showPassword, schema) =>
    inputs?.email && !showPassword
      ? schema.email('Must be a valid email').required('Required field').max(50)
      : undefined
  ),

  phone: Yup.string().when(['$inputs', '$showPassword'], (inputs, showPassword, schema) =>
    inputs?.phone && !showPassword ? schema.required('Required field') : undefined
  ),

  legal1: Yup.boolean().when(['$checkbox', '$showPassword'], (checkbox, showPassword, schema) =>
    !!checkbox?.legal1 && !showPassword ? schema.oneOf([true], 'Required condition') : undefined
  ),

  legal2: Yup.boolean().when(['$checkbox', '$showPassword'], (checkbox, showPassword, schema) =>
    !!checkbox?.legal2 && !showPassword ? schema.oneOf([true], 'Required condition') : undefined
  )
});
